import { InjectionToken } from '@angular/core';

/**
 * Injection token for shell-configured protected resource URL prefixes. The shell provides this from its resolved
 * environment configuration so the shared HTTP interceptor can attach tokens without reading shell runtime globals.
 */
export const AUTH_PROTECTED_RESOURCE_URLS = new InjectionToken<readonly string[]>('AUTH_PROTECTED_RESOURCE_URLS');
